import styled from "@emotion/styled";
import { subPageMixin } from "../mixin";

export const SubPageSection = styled.section(subPageMixin);

SubPageSection.displayName = "SubPageSection";
